// extracted by mini-css-extract-plugin
export var copyable = "_i-1";
export var explainable = "_i-0";
export var negative = "_i-2";
export var positive = "_i-3";